import Spinner from '@components/Spinner'
import React from 'react'
import { Centered, SpinnerWrap, StateMessage } from './PublicPageState.styles'

interface PublicLoadingStateProps {
	/** Per-page wording, e.g. "Loading trip…". */
	label: string
}

/**
 * Centered spinner + label shown while a public share page's query is in
 * flight. Shared by every `/shared/trips/...` page so the loading treatment
 * cannot drift between them; the page supplies its own wording.
 */
const PublicLoadingState: React.FC<PublicLoadingStateProps> = ({ label }) => (
	<Centered>
		<SpinnerWrap>
			<Spinner />
		</SpinnerWrap>
		<StateMessage>{label}</StateMessage>
	</Centered>
)

export default PublicLoadingState
